import { apiAxios } from '@/lib/apiAxios';
const BASE = '/internal/workspaces';
export const fetchInternalWorkspaces = async () => apiAxios.get(BASE).then((r) => r.data);
export const setInternalWorkspace = async ({ publicId, enabled, }) => apiAxios
    .post(`${BASE}/${publicId}/internal`, { enabled })
    .then((r) => r.data);
